import { useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import ImageUpload from "@/components/editor/image-upload/image-upload-component";
import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";
import { Input } from "@/components/shared/forms";

export default function ImageSettings() {
  const { id, blockType, altText, actions } = useNode((node) => ({
    blockType: node.data.props?.blockType,
    altText: node.data.props?.alt ?? "",
  }));
  const { t } = useTranslation();

  return (
    <SettingsTitleWrapper title="Image">
      <div className="grid gap-2">
        <ImageUpload nodeId={id} imagePropName="src" blockType={blockType} />
        <p className="text-sm leading-6 text-gray-600">
          {t("preference-panel.please-use-formats")}
        </p>
        <Input
          className="mt-4"
          name="a"
          value={altText}
          onChange={(e) => {
            actions.setProp((props) => {
              props.alt = e.currentTarget.value;
            });
          }}
          label={t("preference-panel.image-alt-text")}
        />
      </div>
    </SettingsTitleWrapper>
  );
}
